import { Component, inject, OnInit, viewChild } from '@angular/core';
import { Sidebar } from '../sidebar/sidebar';
import { Header } from '../header/header';
import { RouterOutlet } from '@angular/router';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import { LoadingOverlayComponent } from '../../shared/components/loading-overlay/loading-overlay.component';

@Component({
  selector: 'app-main-layout',
  imports: [RouterOutlet, Header, Sidebar, ToastContainerDirective, LoadingOverlayComponent],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss',
})
export class MainLayout implements OnInit {
  toastrService = inject(ToastrService);

  toastContainer = viewChild(ToastContainerDirective);

  ngOnInit() {
    this.toastrService.overlayContainer = this.toastContainer();
  }
}
